<script setup lang="ts">
import BaseDialog from "@/stories/dialogs/BaseDialog.vue";

export type DialogSizes = "xs" | "sm" | "base" | "md" | "lg";

interface Props {
  size?: DialogSizes;
}

withDefaults(defineProps<Props>(), {
  size: "md",
});

defineEmits<{ close: [] }>();

const WIDTH_MAP: Record<DialogSizes, string> = {
  xs: "desktop:w-[30rem]",
  sm: "desktop:w-[31.25rem]",
  base: "desktop:w-[37.5rem]",
  md: "desktop:w-[62.5rem]",
  lg: "desktop:w-[87.5rem]",
};
</script>

<template>
  <BaseDialog @on-close="$emit('close')">
    <div
      :class="[
        'bg-white overflow-hidden flex flex-col justify-between w-full',
        'fixed top-0 left-0 h-dvh',
        'laptop:static laptop:left-auto laptop:h-auto laptop:max-h-[80dvh] laptop:w-[52rem]',
        WIDTH_MAP[size],
      ]"
    >
      <slot></slot>
    </div>
  </BaseDialog>
</template>
